<template>
  <NuxtLayout name="standard">
    <SSection v-if="accessibilityPageData" :has-separator="false">
      <ConnectifTag :name="CONNECTIF_PAGE_TAGS.OTHERS" />
      <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.OTHERS" />

      <SMarkdown v-bind="markdown" />
    </SSection>
    <SSpacer />
  </NuxtLayout>
</template>

<script setup lang="ts">
// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Types
import { type schemaType as accessibilityPageSchemaType } from '~~/shared/api/strapi/accessibility-page/schema'

// Composables
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'

// Apis
import { serverFetch as getAccessibilityPageData } from '~~/modules/api/strapi/accessibility-page'

// Transformers
import { useToSMarkdown } from '~/composables/transformers/useToSMarkdown'

// Components Props
import type { propsInterface as smarkdownProps } from '~~/modules/design-system/sections/s-markdown.vue'

const { setHeadInfo } = useHeadInfoComposable()

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const dataApiDetail = await getAccessibilityPageData()

let accessibilityPageData: accessibilityPageSchemaType
let markdown: smarkdownProps

if (dataApiDetail.success && dataApiDetail.success.data) {
  accessibilityPageData = dataApiDetail.success.data

  if (accessibilityPageData) {
    setHeadInfo({
      title: accessibilityPageData.attributes.head.title,
      description: accessibilityPageData.attributes.head.description,
      images: [
        {
          url: accessibilityPageData.attributes.head.image.data.attributes.url,
          alt: accessibilityPageData.attributes.head.title,
        },
      ],
    })

    markdown = {
      text: useToSMarkdown().fromStrapiAccessibilityPage(accessibilityPageData),
      responsive: true,
      clear: true,
    }

    const breadCrumbMenuStore = useMenuBreadcrumbStore()
    breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.accessibility'))
  }
} else if (dataApiDetail.error) {
  showErrorPage(dataApiDetail.error as ApiResponseError)
}

sendConnectifPage()
</script>
